<div [formGroup]="parentForm()">
  <!-- Follow Up Task -->
  <div>
    <!-- Follow Up Task Header -->
    <div class="surface-200 py-2 px-3 border-round font-bold text-sm">
      <i class="fa fa-list mr-2"></i>
      <span>{{'Shared.CREATE-PROSPECT.CREATE_FOLLOW_UP_TASK' | translate}}</span>
    </div>
    <!-- Follow Up Task Header -->

    <!-- Follow Up Task Content -->
    <div class="md:px-3 pt-3">
      <div class="grid">
        <div class="col-12 md:col-4">
          <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="task-type-label">{{'Shared.CREATE-PROSPECT.LABEL_TASKTYPE' | translate}}</label>
          <p-select [options]="taskTypeCollection" formControlName="taskType" placeholder="Select..."
            styleClass="w-full" aria-label="select-task-type-dropdown" data-testid="select-task-type">
            <ng-template pTemplate="selectedItem">
              @if (parentForm().get('taskType')?.value) {
                <div class="task-item task-item-value flex align-items-center">
                  <i class="mr-3 {{parentForm().get('taskType')?.value.icon}}"></i>
                  <div class="text-sm">{{parentForm().get('taskType')?.value.name}}</div>
                </div>
              }
            </ng-template>
            <ng-template let-task pTemplate="item">
              <div class="task-item flex align-items-center">
                <i class="mr-3 {{task.icon}}"></i>
                <div class="text-sm">{{task.name}}</div>
              </div>
            </ng-template>
          </p-select>
          @if (parentForm().get('taskType')?.touched && parentForm().get('taskType')?.invalid) {
            <app-error-msg [errors]="parentForm().get('taskType')?.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.TASKTYPE' | translate"
              data-testid="task-type-error" />
          }
        </div>

        <div class="col-12 md:col-4">
          <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="task-on-label">{{'Shared.CREATE-PROSPECT.LABEL_TASKON' | translate}}</label>
          <p-select [options]="taskOnCollection" formControlName="taskOn" optionLabel="name" placeholder="Select..." styleClass="w-full"
            aria-label="select-task-on-dropdown" data-testid="select-task-on">
            <ng-template pTemplate="selectedItem">
              @if (parentForm().get('taskOn')?.value; as taskOn) {
                <div class="text-sm">
                  {{ taskOn.name}}
                </div>
              }
            </ng-template>
            <ng-template let-taskOn pTemplate="item">
              <div class="text-sm">{{taskOn.name}}</div>
            </ng-template>
          </p-select>

          @if (parentForm().get('taskOn')?.touched && parentForm().get('taskOn')?.invalid) {
            <app-error-msg [errors]="parentForm().get('taskOn')?.errors" [fieldLabel]="'Shared.CREATE-PROSPECT.TASKON' | translate"
              data-testid="task-on-error" />
          }
        </div>

        <div class="col-12 md:col-4">
          @if (parentForm().get('taskOn')?.value && parentForm().get('taskOn')?.value?.value && parentForm().get('taskOn')?.value?.value.toLowerCase() === 'custom date') {
            <p-datepicker formControlName="taskOnDate"
              [showIcon]="true" dateFormat="dd/mm/yy" [minDate]="minDate" placeholder="Select custom date"
              styleClass="w-full mt-2"
              aria-label="task-on-date-input"
              data-testid="task-on-date-input" />
          }
        </div>

        <div class="col-12">
          <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="task-notes-label">{{'Shared.CREATE-PROSPECT.NOTES' | translate}}</label>
          <textarea pTextarea formControlName="notes" class="w-full"
            placeholder="{{'Shared.CREATE-PROSPECT.NOTES' | translate}}" aria-label="task-notes-input" data-testid="task-notes">
          </textarea>
        </div>
      </div>
    </div>
    <!-- Follow Up Task Content -->
  </div>
  <!-- Follow Up Task -->

  <!-- Create an Opportunity -->
  <div class="md:px-3 col-12">
    <div class="grid">
      <div class="flex align-items-center mb-3 col-12 md:col-4">
        <span class="mr-6 text-sm font-bold line-height-1 mb-0">{{'CLIENT_PROFILE.CREATE_OPPORTUNITY' | translate}}</span>
        <p-toggleSwitch formControlName="createOpportunity" aria-label="toggle-create-opportunity-switch" data-testid="toggle-create-opportunity" />
      </div>

      @if (parentForm().get('createOpportunity')?.value) {
        <div class="col-12 md:col-4 pt-0">
          <label class="font-medium text-700 text-xs mb-2 block uppercase" data-testid="interested-in-label">{{'Shared.TASK-OPPORTUNITY-INFO.INTERESTED-IN' | translate}}</label>
          <p-multiSelect [options]="interestedInCollection" formControlName="interestedIn"
            placeholder="{{'ADMIN.COMMON.SELECT' | translate}}" optionLabel="name"
            styleClass="w-full text-sm" aria-label="select-interested-in-dropdown" data-testid="select-interested-in" />
          @if (parentForm().get('interestedIn')?.touched && parentForm().get('interestedIn')?.invalid) {
            <app-error-msg [errors]="parentForm().get('interestedIn')?.errors"
              [fieldLabel]="'Shared.TASK-OPPORTUNITY-INFO.INTERESTED-IN' | translate"
              data-testid="interested-in-error" />
          }
        </div>
      }
    </div>
  </div>
  <!-- Create an Opportunity -->
</div>